import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowsRotate,
  faBan,
  faBoxArchive,
  faCircleCheck,
  faCircleXmark,
  faCreditCard,
  faEnvelopeOpenText,
  faHourglassHalf,
  faLayerGroup,
  faMoneyBillWave,
  faTableColumns,
  faPaperPlane,
  faUsers,
  faUsersGear,
} from "@fortawesome/free-solid-svg-icons";

/** Single primary nav entry with optional nested links */
export type SideBarNavItem = {
  label: string;
  route: string;
  icon: IconDefinition;
  subData?: { label: string; route: string }[];
};

const SideBarData: SideBarNavItem[] = [
  { label: "Dashboard", route: "/", icon: faTableColumns },
  { label: "Chase List", route: "/chaselist", icon: faLayerGroup },
  {
    label: "Inviting",
    route: "/chase/Inviting",
    icon: faPaperPlane,
    subData: [],
  },
  {
    label: "Auto-Renewals",
    route: "/chase/Auto-Renewals",
    icon: faArrowsRotate,
  },
  {
    label: "Auto Payment Attempt",
    route: "/due-to-auto",
    icon: faHourglassHalf,
  },
  {
    label: "Payment-Failed",
    route: "/chase/Payment-Failed",
    icon: faCircleXmark,
  },
  {
    label: "Payment Declined",
    route: "/payment-declined",
    icon: faCreditCard,
  },
  {
    label: "Payment Received",
    route: "/chase/Payment-Received",
    icon: faMoneyBillWave,
  },
  { label: "Renewed", route: "/chase/Renewed", icon: faCircleCheck },
  { label: "Lapsed", route: "/chase/Lapsed", icon: faBan },
  {
    label: "Customer Archives",
    route: "/customer-archives",
    icon: faBoxArchive,
  },
  { label: "My Customers", route: "/my-customers", icon: faUsers },
  { label: "Agents", route: "/agents", icon: faUsersGear },
  {
    label: "Message Templates",
    route: "/message-templates",
    icon: faEnvelopeOpenText,
  },
];

export default SideBarData;
